import { render } from "./AvatarView.vue?vue&type=template&id=b1f75b2a&scoped=true"
import script from "./AvatarView.vue?vue&type=script&lang=js"
export * from "./AvatarView.vue?vue&type=script&lang=js"

import "./AvatarView.vue?vue&type=style&index=0&id=b1f75b2a&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-b1f75b2a"]])

export default __exports__